<template>
    <div>
        <div>Pool Contribution</div>
        <table class="table table-bordered" width="50%">
            <thead>
                <tr>
                    <th class="bg-dark text-white py-2">#</th>
                    <th class="bg-dark text-white py-2">Pool</th>
                    <th class="bg-dark text-white py-2">Pool Type Code</th>
                    <th class="bg-dark text-white py-2">Frequency Code</th>
                    <th class="bg-dark text-white py-2">Pool Date Range</th>
                    <th class="bg-dark text-white py-2">Pool <br>Contribution <br>Percentage <br>(%)</th>
                    <th class="bg-dark text-white py-2">Pool <br>Contribution <br>Amount <br>(RM)</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(pool_contribution_detail, index) in currentCommsPayoutSummary.pool_contribution_details" :key="index">
                    <td class="py-2">{{ index+1 }}</td>
                    <td class="py-2">{{ pool_contribution_detail.pool.pool_name }}</td>
                    <td class="py-2">{{ pool_contribution_detail.pool.pool_type_code }}</td>
                    <td class="py-2">{{ pool_contribution_detail.pool.frequency_code }}</td>
                    <td class="py-2">{{ pool_contribution_detail.pool.pool_from_date }} - {{ pool_contribution_detail.pool.pool_to_date }}</td>
                    <td class="py-2">{{ pool_contribution_detail.pool_contribution_percentage | moneyFormatter }}</td>
                    <td class="py-2">RM {{ pool_contribution_detail.pool_contribution_amount | moneyFormatter }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
  props: ['currentCommsPayoutSummary'],
}
</script>